export function looksLikeImageUrl(str) {
  if (!str || typeof str !== 'string') return false;
  return str.includes('firebasestorage.googleapis.com')
    || /\.(png|jpg|jpeg|gif|webp|svg)(\?|$)/i.test(str);
}

export function isImage(explicitType, content) {
  return explicitType === 'image' || looksLikeImageUrl(content);
}

export function isArabic(text) {
  return /[\u0600-\u06FF]/.test(text);
}

const TTS_MUTE_KEY = 'tts_muted';

export function isTtsMuted() {
  return localStorage.getItem(TTS_MUTE_KEY) === '1';
}

export function toggleTtsMute() {
  const next = !isTtsMuted();
  localStorage.setItem(TTS_MUTE_KEY, next ? '1' : '0');
  if (next && typeof window.speechSynthesis !== 'undefined') {
    try { window.speechSynthesis.cancel(); } catch (_) {}
  }
  return next;
}

export function speakWord(text) {
  if (isTtsMuted() || !text || typeof window.speechSynthesis === 'undefined') return;
  if (isArabic(text)) return;
  try {
    const synth = window.speechSynthesis;
    synth.cancel();
    synth.resume();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = 'en-US';
    u.rate = 0.9;
    const voices = synth.getVoices();
    const enVoice = voices.find(v => v.lang.startsWith('en'));
    if (enVoice) u.voice = enVoice;
    synth.speak(u);
  } catch (_) {}
}

export function formatTime(ms) {
  if (!Number.isFinite(ms) || ms < 0) ms = 0;
  const totalSec = Math.floor(ms / 1000);
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  if (min === 0) return `${sec} ثانية`;
  return `${min} دقيقة و ${sec} ثانية`;
}

export function shuffleArray(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function shuffleInPlace(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export function truncateText(text, max = 70) {
  if (!text) return '—';
  const single = text.replace(/\n/g, ' ');
  return single.length > max ? single.slice(0, max) + '…' : single;
}

export async function copyToClipboard(text) {
  if (!navigator.clipboard?.writeText) return false;
  try { await navigator.clipboard.writeText(text); return true; } catch { return false; }
}

export function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function yesterdayStr() {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
